import { SHStack, SHStackProps } from "@components/design-systems";
import SHSkeleton, {
  SHSkeletonProps,
} from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";

type Props = {
  numOfOptions?: number;
  skeletonProps?: SHSkeletonProps;
} & SHStackProps;
export const SHToggleButtonOptionsSkeleton = ({
  numOfOptions = 3,
  skeletonProps,
  ...others
}: Props) => {
  const { palette } = useTheme();

  return (
    <SHStack
      border={`1px solid ${palette.divider}`}
      borderRadius={"100px"}
      height={30}
      width={"200px"}
      padding={"2px"}
      spacing={0.5}
      direction="row"
      {...others}
    >
      {Array.from(Array(numOfOptions)).map((_, index) => (
        <SHSkeleton
          key={index}
          height={"100%"}
          width={"calc(100%/3)"}
          sx={{ borderRadius: "100px" }}
          delay={false}
          {...skeletonProps}
        />
      ))}
    </SHStack>
  );
};
